export enum UserStatus {
  registered = 0,
  accepted = 1,
  closed = 2
}